import { createSelector } from 'reselect'

export const getRegistrationFormulas = createSelector(state => state && state.ads.detail &&
state.ads.detail.registrationFormulas ? state.ads.detail.registrationFormulas : [],
registrationFormulas => registrationFormulas
)
